import { a as patchEsm, b as bootstrapLazy } from './index-f382ec8b.js';
var defineCustomElements = function (win, options) { return patchEsm().then(function () {
    return bootstrapLazy([["glitch-image", [[1, "glitch-image", { "src": [1], "isEnabled": [32], "glitchCount": [32], "glitchSequenceCount": [32], "glitchWidth": [32], "glitchTop": [32], "glitchLeft": [32] }]]]], options);
}); };
export { defineCustomElements };
